<template>
  <div id="header__container">
    <div id="appheader">
      <div id="header_ts">
          telenor | satellite 
      </div>
      <div id="header_title">
          
      </div>
      <nav id="header_menu" >
      </nav>
    </div>
    <info-banner id="infobanner__container"></info-banner>
  </div>
</template>

<script>
import infoBanner from '../components/infoBanner'

export default {
  name: 'theHeader',
  data(){
    return{
      showMenu: false
    }
  },
  computed: {
  },
  methods: {
    signOut(){
      this.$store.dispatch('signOut');
    }
  },
  components:{
    infoBanner
  }
}
</script>

<style scoped lang="scss">
  #header__container{
    position: relative;
  }

  #infobanner__container{
    position: absolute;
    display: block;
    width: 100%;

    @media only screen and (min-width: $bp-large) {
      width: calc(100vw - 8rem);
      left: 8rem;
    }

  }

  #appheader{
    background-color: $telenor-black;
    margin: 0;
    padding: 1rem;
    height: 6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    flex-flow: row nowrap;
  }

  #header_ts{
    font-size: 3rem;
    text-align: left;

    &:hover{
      cursor: pointer;
    }
  }

  #header_title{
      font-size: 2.4rem;
      text-align: center;
  }

  #header_menu{
    font-size: 2.4rem;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    
    a{
      padding: .5rem .5rem;
      color: $telenor-light-grey-1;
      text-decoration: none;

      &:hover{
        cursor: pointer;
        color: white;
      }
    }

    .active{
      text-decoration: underline;
      color: white;
    }

    .router-link-active{
      color: white;
    }
  }

  // Dropdown menu
  .dropdown-menu{
    width: 5rem;
  }

  .dropdown-btn{
    display: inline-block;
    cursor: pointer;

    .bar1, .bar2, .bar3 {
      width: 35px;
      height: 5px;
      background-color: #fff;
      margin: 6px 0;
      transition: 0.4s;
    }

    /* Rotate first bar */
    .change.bar1 {
      -webkit-transform: rotate(-45deg) translate(-9px, 6px) ;
      transform: rotate(-45deg) translate(-9px, 6px) ;
    }

    /* Fade out the second bar */
    .change.bar2 {
      opacity: 0;
    }

    /* Rotate last bar */
    .change.bar3 {
      -webkit-transform: rotate(45deg) translate(-8px, -8px) ;
      transform: rotate(45deg) translate(-8px, -8px) ;
    }
  }

  .dropdown-content{
    margin-top: 1.5rem;
    position: absolute;
    background-color: $telenor-black;
    color: $telenor-white;
    width: 100%;
    height: calc(100vh - 7.5rem);
    box-shadow: 0 .8rem 1.6rem 0 rgba(0,0,0,0.2);
    z-index: 1;
    right: 0;
    top: 6rem;

    .dropdown-items{
      display: flex;
      flex-direction: column;
      justify-content:center;
      align-items: center;
      // text-align: left;
      
      a {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: .5rem 2rem .5rem .3rem;

        &:not(:last-child){
          margin-bottom: 1rem;
        }
        
        img{
          height: 2.5rem;
          width: 2.5rem;
          margin-right: .5rem;
        }

        &:hover{
          background: $telenor-link;
        }
      }
    }
  }

  // Transitions
  .slide-enter-active {
    transition: height .3s linear;
  }

  .slide-leave-active {
    transition: height .3s linear;
  }

  .slide-enter-to, .slide-leave {
    height: calc(100vh - 7.5rem);
    overflow: hidden;
  }

  .slide-enter, .slide-leave-to {
    overflow: hidden;
    height: 0;
  }

</style>